/** Чат за поддръжка на всяка страница. Отговорите следват условията на сайта. */
export default {
  open: "Поддръжка",
  close: "Затвори чата",
  title: "Поддръжка",
  subtitle: "Тук отговаряме на чести въпроси. На съобщение отговаря човек в рамките на един работен ден.",
  greeting:
    "Здравейте. Мога да помогна с планове, плащания, точки и възстановяване на суми. Ако ви трябва човек, оставете съобщение и ще отговорим в рамките на един работен ден.",
  placeholder: "Задайте въпрос…",
  send: "Изпрати",
  leaveMessage: "Оставете съобщение",
  topics: {
    hours: "Работно време",
    refund: "Възстановяване",
    payment: "Плащания",
    human: "Човек от екипа",
  },
  answers: {
    hours:
      "Обслужването на клиенти отговаря на съобщения от понеделник до петък, 09:00 – 18:00 ч. (българско време). Отговаряме в рамките на един работен ден.",
    refund:
      "Първото плащане на Starter, Pro или Elite има 30-дневна гаранция: пълно възстановяване, ако не сте използвали точките, или стойността на неизползваните, ако сте. Планът Custom следва същото правило за 14 дни. Пишете на support@aistylemedia.com с имейла, с който сте поръчали, и номера на поръчката. Номерът е в имейла за потвърждение и в историята на поръчките.",
    payment:
      "Всеки план е еднократно плащане за пакет точки. Нищо не се подновява автоматично. Плащате с карта на защитената страница на Банка ДСК или Пощенска банка. Цените са в евро и включват всички данъци.",
    points:
      "Изображение струва 1 точка, а видеоклип — 2. Нов профил получава 10 безплатни точки еднократно. Платените точки се добавят след потвърждение от банката. Ако след 30 минути все още ги няма, оставете съобщение с номера на поръчката.",
    pricing:
      "Starter, Pro и Elite са еднократни пакети точки. Можете и да изберете своя сума от 10 € на страницата с цените. Таксуваме ви само когато направите поръчка.",
    account:
      "Влезте от „Вход“, за да отворите профила си. Ако сте платили без профил, създайте такъв със същия имейл, който сте използвали при поръчката, и точките са там.",
    contact:
      "Пишете на support@aistylemedia.com или на Info@aistylemedia.com, или оставете съобщение в този чат. Отговаряме в рамките на един работен ден, понеделник – петък, 09:00 – 18:00 ч. (българско време).",
    human:
      "Оставете име, имейл и въпрос по-долу. Съобщението отива при обслужването на клиенти и човек отговаря в рамките на един работен ден.",
  },
  fallback:
    "Нямам отговор на това. Оставете съобщение или пишете на support@aistylemedia.com и човек ще отговори в рамките на един работен ден.",
  form: {
    name: "Име",
    email: "Имейл",
    message: "Съобщение",
    messageHint: "До 500 знака.",
    send: "Изпрати до поддръжката",
    sending: "Изпращане…",
    nameRequired: "Моля, въведете име.",
    emailRequired: "Моля, въведете валиден имейл адрес.",
    messageRequired: "Моля, въведете съобщение.",
    success: "Съобщението е изпратено. Ще отговорим на този имейл в рамките на един работен ден.",
    subject: "Чат за поддръжка",
  },
};
